export const services = {
	services: {
		title: "サービス",
		description: "提供中のサービス一覧",
		adSpaces: {
			title: "広告枠販売",
			subtitle: "リリース済みアプリへの広告掲載",
			description: "累計20以上の個人開発アプリに、バナー広告などを掲載することができます。アプリのターゲット層に合わせた効果的な広告配信が可能です。",
			viewDetails: "詳細を見る",
		},
	},

	adSpaces: {
		title: "広告枠販売",
		subtitle: "リリース済みアプリへの広告掲載サービス",
		description: "累計20以上の個人開発アプリに、バナー広告などを掲載することができます。",
		features: {
			title: "サービスの特徴",
			items: [
				{
					title: "多様なアプリポートフォリオ",
					description: "シフト管理、掲示板閲覧、AI統合アプリなど、様々なジャンルのアプリに広告掲載が可能",
				},
				{
					title: "柔軟な広告配置",
					description: "バナー広告、インタースティシャル広告など、アプリに応じた最適な広告配置をご提案",
				},
				{
					title: "透明性の高いレポート",
					description: "定期的なPV数やインプレッション数などのレポートを提供",
				},
			],
		},
		stats: {
			title: "主要アプリのPV数（月間）",
			note: "※ 2026年1月時点の実測値",
		},
		contact: {
			title: "お問い合わせ",
			description: "広告掲載に関するご相談は、以下のメールアドレスまでお気軽にお問い合わせください。",
			emailButton: "メールで問い合わせる",
			note: "※ 通常1-2営業日以内に返信いたします。",
		},
		backToServices: "サービス一覧に戻る",
	},
} as const;
